// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vHPa","title":"Info_title__3Nwen","links":"Info_links__3BALy","link":"Info_link__3CT1B","logo":"Info_logo__2KuLc"};